import { EvaluationContext } from '@coast/schemas';
import { getStore } from '@shared/store';

export const defaultEvaluationContext: EvaluationContext = {
  resolveCurrentUserId: () => getStore().getState().appState.currentUserId,
};
